import { compose } from "redux";

// @ts-ignore
import ResetPassword from "../src/resetPassword/ResetPassword";
import withAuthentication from "../src/withAuthentication";
// @ts-ignore
import { RESET_PASSWORD, permissions } from "../src/routes";

export default compose(withAuthentication(permissions[RESET_PASSWORD]))(
  ResetPassword,
);
